export default __webpack_public_path__ + "static/media/CMS_Chargers.d235d9f5.svg";